import axios from "axios"
import Vue from "vue"
import unauthorizedHandler from "@/util/refresh-on-unauthorized"
import * as _ from "lodash"

const { VUE_APP_BASE_URL } = process.env

axios.defaults.baseURL = VUE_APP_BASE_URL
axios.defaults.withCredentials = true

const axiosInstance = axios.create()
const frontendVersion = process.env.VERSION

axiosInstance.interceptors.response.use(response => {
  if (exists(response.data.status) && response.data.status === 200) {
    response.data = response.data.content
  }

  const backendVersion = response.headers["easyship-backend-version"]

  if (!_.isNil(backendVersion) && backendVersion !== frontendVersion) {
    window.location.reload()
  }

  return response
}, unauthorizedHandler)
Vue.prototype.$http = axiosInstance
Vue.$http = axiosInstance
